
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/mediabank",
      function () {
        return require("private-next-pages/media/mediabank/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/mediabank"])
      });
    }
  